import { Styles } from '@typings/common';

export const iconButton: Styles = {
  '&.MuiSelect-icon': {
    top: 'calc(50% - 0.875em)',
    pointerEvents: 'auto',
  },
};
